import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import {formatDate} from '@pb/kit-formatters';

export const getAttachmentCreationDate = (
    attachment: TriggerAttachment,
): string => attachment.creationDate ? formatDate(attachment.creationDate) : 'new';
